import Vue from 'vue';
import App from './App.vue';
import './plugins/element.js';
import * as firebase from 'firebase/app';
import 'firebase/database';

Vue.config.productionTip = false;

const config = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDERID,
};
firebase.initializeApp(config);
firebase.database();

new Vue({
  render: (h) => h(App),
}).$mount('#app');
